module.exports = __webpack_public_path__ + "static/media/tarjeta-mastercard.8ebc1bfd.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/montemar-card-calf/img/tarjeta-mastercard.png
 ** module id = 2063
 ** module chunks = 0
 **/